import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/office1.jpg'


const _withScopeId = n => (_pushScopeId("data-v-ccfeb0cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col" }
const _hoisted_2 = { class: "responsive-flex-centered mb-sm mx-sm" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "presentation-img"
}, null, -1))
const _hoisted_4 = { class: "flex-centered" }
const _hoisted_5 = {
  align: "justify",
  class: "presentation-text p-md"
}
const _hoisted_6 = { class: "m-sm text-center" }
const _hoisted_7 = { class: "responsive-flex g-md flex-evenly m-sm" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"text-decoration":"none","color":"black"} }
const _hoisted_10 = {
  style: {"width":"300px"},
  class: "flex-centered"
}
const _hoisted_11 = { style: {"font-weight":"100"} }
const _hoisted_12 = { class: "flex-centered" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "client-text text-center" }
const _hoisted_15 = { style: {"overflow":"auto","max-height":"140px"} }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = ["href"]

import type { ImgSliderItemConfig } from "@/types/slider";
import { computed, ref } from "vue";
import homeImages from "@/assets/imgs/slides/home";
import type { ActivityItemConfig } from "@/types/menu";
import type { ClientMemberConfig, TeamMemberConfig } from "@/types/persons";
import { useI18n } from "vue-i18n";
import { Navigation } from "swiper";
import { useScreen } from "@/composables/screen";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const { t } = useI18n();
const { screenWidth } = useScreen();

const imgSliderItems = computed((): ImgSliderItemConfig[] => {
  const slides: ImgSliderItemConfig[] = [];
  let i = 0;
  for (const img of homeImages) {
    slides.push({
      id: `home-page-slide-${i}`,
      src: img,
    });
    i++;
  }
  return slides;
});

const activitiesItems = ref<ActivityItemConfig[]>([
  {
    name: "prefabricated",
    url: "/activity/prefabricated",
    img: require("@/assets/imgs/activities/prefabricated.jpg"),
  },
  {
    name: "coffrage",
    url: "/activity/coffrage",
    img: require("@/assets/imgs/activities/coffrage.jpg"),
  },
  {
    name: "mansory",
    url: "/activity/mansory",
    img: require("@/assets/imgs/activities/mansory.jpg"),
  },
  {
    name: "steel",
    url: "/activity/steel",
    img: require("@/assets/imgs/activities/steel.jpg"),
  },
]);

const teamMembers = ref<TeamMemberConfig[]>([
  {
    name: "Cesar Marques",
    function: "functions.founder",
    description: "cesar_desc",
  },
  {
    name: "Tiago Lopes",
    function: "functions.engineer",
    description: "tiago_desc",
  },
  {
    name: "Daniel Jose Teixeira",
    function: "functions.big_work_responsable",
    description: "daniel_desc",
  },
  {
    name: "Andre Coelho",
    function: "functions.responsable_general",
    description: "andre_desc",
  },
  {
    name: "Carlos Oliveira",
    function: "functions.lux_responsable",
    description: "carlos_desc",
  },
  {
    name: "Antonio Moreira",
    function: "functions.formworker_responsable",
    description: "antonio_desc",
  },
]);

const clients = ref<ClientMemberConfig[]>([
  {
    name: "Franki",
    website: "https://willemen.be/fr/entrepreneur/franki-construct",
    description: "franki_desc",
    img: require("@/assets/imgs/clients/franki.png"),
  },
  {
    name: "BESIX Group",
    website: "https://www.besix.com/en/",
    description: "besix_desc",
    img: require("@/assets/imgs/clients/besix.png"),
  },
  {
    name: "Vandenbussche",
    website: "https://www.vandenbusschebouw.be/",
    description: "vandenbussche_desc",
    img: require("@/assets/imgs/clients/vandenbussche.png"),
  },
  {
    name: "Cosimco",
    website: "  https://www.willemen.be/en/aannemer/cosimco",
    description: "cosimco_desc",
    img: require("@/assets/imgs/clients/cosimco.png"),
  },
  {
    name: "B&R",
    website: "https://benrbouwgroep.be/",
    description: "benrbouwgroep_desc",
    img: require("@/assets/imgs/clients/benrbouwgroep.png"),
  },
  {
    name: "Wyckaert",
    website: "https://www.wyckaert.eu/",
    description: "wyckaert_desc",
    img: require("@/assets/imgs/clients/wyckaert.png"),
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_ImgSlider = _resolveComponent("ImgSlider")!
  const _component_ContentBloc = _resolveComponent("ContentBloc")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_ImgSlider, {
        items: _unref(imgSliderItems),
        height: "60vh"
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_ContentBloc, {
      class: "outlined-bloc p-md",
      title: _unref(t)('presentation.title'),
      "sub-title": _unref(t)('presentation.subtitle')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("presentation.content")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "sub-title"]),
    _createVNode(_component_ContentBloc, {
      title: _unref(t)('activities.title'),
      class: "p-md"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)("activities.homeIntro")), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activitiesItems.value, (act) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: act.name,
              class: "flex-centered flex-col",
              to: act.url,
              style: {"text-decoration":"none","color":"black"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: act.img,
                  class: "activity-image mb-sm",
                  style: {"width":"160px","height":"160px"}
                }, null, 8, _hoisted_8),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(t)(act.name)), 1)
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_ContentBloc, {
      title: _unref(t)('team'),
      class: "outlined-bloc p-md"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Swiper, {
          modules: [_unref(Navigation)],
          navigation: true,
          "slides-per-view": Math.round(_unref(screenWidth) / 400),
          "center-insufficient-slides": true,
          "centered-slides": true,
          "centered-slides-bounds": true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamMembers.value, (member, i) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, { key: i }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_CardItem, {
                      title: member.name
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)(member.function)), 1)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)(member.description)), 1)
                      ]),
                      _: 2
                    }, 1032, ["title"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules", "slides-per-view"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_ContentBloc, {
      title: _unref(t)('clients'),
      class: "p-md"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Swiper, {
          modules: [_unref(Navigation)],
          navigation: true,
          "slides-per-view": Math.round(_unref(screenWidth) / 800),
          "center-insufficient-slides": true,
          "centered-slides": true,
          "centered-slides-bounds": true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value, (client, i) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, { key: i }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_CardItem, {
                      title: client.name,
                      "container-class": "primary-card",
                      "title-class": "secondary-subtitle"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)(client.description)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              href: client.website,
                              target: "_blank"
                            }, [
                              _createElementVNode("img", {
                                src: client.img,
                                style: {"width":"100px","height":"100px","object-fit":"contain"}
                              }, null, 8, _hoisted_17)
                            ], 8, _hoisted_16),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("a", {
                                href: client.website,
                                target: "_blank",
                                class: "link"
                              }, _toDisplayString(_unref(t)("website")), 9, _hoisted_19)
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["title"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules", "slides-per-view"])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})